import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import HomeBloc from "../../../../bloc/home_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import Config from "../../../../Config";

import AppSelectButton from "../../../component/app_select_button/app_select_button";
import AppTextField from "../../../component/app_text_field/app_text_field";
import "./proposal_form.css";
import AppCheckboxGroup from "../../../component/app_checkbox/app_checkbox";
import UtilBloc from "../../../../bloc/util_bloc";
class GeneralOccupationQuestionnaire extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            generalOccupationData: {
                //form start
                occupation: null,
                isJobScopeHeavy: "No",
                isJobScopeHighOrLow: "No",
                isJobScopeChemical: "No",
                isJobScopeVoltages: "No",
                isJobScopeEquipment: "No",
                isJobScopeVessels: "No",
                isJobScopeTravelAirCraft: "No",
                isJobScopeEnv: "No",
                isJobScopeNo: "No",
                isAccident: null,
                workingDuration: null,
                isHealtAffectedByOcc: null,
                isChangeWork: null,
            },
            isJobScopeHeavyDetails: null,
            isJobScopeHighOrLowDetails: null,
            isJobScopeChemicalDetails: null,
            isJobScopeEquipmentDetails: null,
            isJobScopeVesselsDetails: null,
            isJobScopeVoltagesDetails: null,
            isJobScopeTravelAirCraftDetails: null,
            isJobScopeEnvDetails: null,
            isAccidentDetails: null,
            isChangeWorkNatureDetails: null,
            //form end
            errorMessage: 'Fill in the required field.',
            isUpdate: false,
        };
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
    }

    initiateData() {
        let formData = this.props.value;
        let stateData = this.state.generalOccupationData;
        formData && Object.keys(formData).map(function (key) {
            stateData[key] = formData[key];
        })
        this.setState({ generalOccupationData: stateData })
    }

    //handle change start
    handleSetFormData = (item, idx) => {
        this.setState({
        })
    }

    //handle change start
    getFormFields() {
        return this.props.fields;
    }

    handleValueChange = (field, val) => {
        let data = this.state.generalOccupationData;
        data[field] = val
        this.setState({ generalOccupationData: data });
        this.onValidateForm();
    }
    handleCheckBoxValueChange = (field, val, childValue) => {
        if (val === true) {
            this.setState((prevState) => ({
                generalOccupationData: {
                    ...prevState.generalOccupationData,  // Maintain existing state
                    [field]: "Yes"
                }
            }), () => {
                this.onValidateForm();
            });
        } else {
            this.setState((prevState) => ({
                generalOccupationData: {
                    ...prevState.generalOccupationData,  // Maintain existing state
                    [field]: "No"
                }
            }), () => {
                this.onValidateForm();
            });
        }
        if (childValue) {
            if (childValue === "All") {
                this.setState((prevState) => ({
                    isJobScopeHeavyDetails: null,
                    isJobScopeHighOrLowDetails: null,
                    isJobScopeChemicalDetails: null,
                    isJobScopeEquipmentDetails: null,
                    isJobScopeVesselsDetails: null,
                    isJobScopeVoltagesDetails: null,
                    isJobScopeTravelAirCraftDetails: null,
                    isJobScopeEnvDetails: null,
                }), () => {
                    this.onValidateForm();
                });
                this.setState((prevState) => ({
                    generalOccupationData: {
                        ...prevState.generalOccupationData,  // Maintain existing state
                        isJobScopeHeavy: "No",
                        isJobScopeHighOrLow: "No",
                        isJobScopeChemical: "No",
                        isJobScopeVoltages: "No",
                        isJobScopeEquipment: "No",
                        isJobScopeVessels: "No",
                        isJobScopeTravelAirCraft: "No",
                        isJobScopeEnv: "No",
                    }

                }), () => {
                    this.onValidateForm();
                });
            }
            else
                this.setState({ [childValue]: null })
        }
    }

    handleExtraFieldFormValueChange = (field, val) => {
        this.setState({ [field]: val }, () => {
            this.onValidateForm();
        });

    }

    onValidateForm = () => {
        const { generalOccupationData, isJobScopeHeavyDetails, isJobScopeHighOrLowDetails, isJobScopeChemicalDetails, isJobScopeVoltagesDetails, isJobScopeEquipmentDetails, isJobScopeVesselsDetails, isJobScopeTravelAirCraftDetails, isJobScopeEnvDetails, isAccidentDetails, isChangeWorkNatureDetails } = this.state;
        const { isJobScopeHeavy, isJobScopeHighOrLow, isJobScopeChemical, isJobScopeEquipment, isJobScopeVessels, isJobScopeVoltages, isJobScopeTravelAirCraft, isJobScopeEnv, isJobScopeNo, isAccident, isChangeWork } = this.state.generalOccupationData;
        let validated = true;
        let stopValidation = false;
        Object.keys(generalOccupationData).map(function (key) {
            if (key === "occupation" || key === "isAccident" || key === "isHealtAffectedByOcc" || key === "workingDuration" || key === "isChangeWork") {
                validated = validated && (!UtilBloc.isNullOrEmpty(generalOccupationData[key]) || false);
                if (!validated) {
                    stopValidation = true; //flag to stop further validation
                }
            }
        });
        if (!stopValidation && isJobScopeHeavy === "No" && isJobScopeHighOrLow === "No" && isJobScopeChemical === "No" && isJobScopeEquipment === "No" && isJobScopeVessels === "No" && isJobScopeVoltages === "No" && isJobScopeTravelAirCraft === "No" && isJobScopeEnv === "No" && isJobScopeNo === "No") {
            validated = false
            if (!validated) {
                stopValidation = true; //flag to stop further validation
            }
        }
        if (!stopValidation && isJobScopeHeavy === "Yes") {
            validated = (!UtilBloc.isNullOrEmpty(isJobScopeHeavyDetails) || false)
            if (!validated) {
                stopValidation = true; //flag to stop further validation
            }
        }
        if (!stopValidation && isJobScopeHighOrLow === "Yes") {
            validated = (!UtilBloc.isNullOrEmpty(isJobScopeHighOrLowDetails) || false)
            if (!validated) {
                stopValidation = true; //flag to stop further validation
            }
        }
        if (!stopValidation && isJobScopeChemical === "Yes") {
            validated = (!UtilBloc.isNullOrEmpty(isJobScopeChemicalDetails) || false)
            if (!validated) {
                stopValidation = true; //flag to stop further validation
            }
        }
        if (!stopValidation && isJobScopeEquipment === "Yes") {
            validated = (!UtilBloc.isNullOrEmpty(isJobScopeEquipmentDetails) || false)
            if (!validated) {
                stopValidation = true; //flag to stop further validation
            }
        }
        if (!stopValidation && isJobScopeVessels === "Yes") {
            validated = (!UtilBloc.isNullOrEmpty(isJobScopeVesselsDetails) || false)
            if (!validated) {
                stopValidation = true; //flag to stop further validation
            }
        }
        if (!stopValidation && isJobScopeVoltages === "Yes") {
            validated = (!UtilBloc.isNullOrEmpty(isJobScopeVoltagesDetails) || false)
            if (!validated) {
                stopValidation = true; //flag to stop further validation
            }
        }
        if (!stopValidation && isJobScopeTravelAirCraft === "Yes") {
            validated = (!UtilBloc.isNullOrEmpty(isJobScopeTravelAirCraftDetails) || false)
            if (!validated) {
                stopValidation = true; //flag to stop further validation
            }
        }
        if (!stopValidation && isJobScopeEnv === "Yes") {
            validated = (!UtilBloc.isNullOrEmpty(isJobScopeEnvDetails) || false)
            if (!validated) {
                stopValidation = true; //flag to stop further validation
            }
        }
        if (!stopValidation && isAccident === "Yes") {
            validated = (!UtilBloc.isNullOrEmpty(isAccidentDetails) || false)
            if (!validated) {
                stopValidation = true; //flag to stop further validation
            }
        }
        if (!stopValidation && isChangeWork === "Yes") {
            validated = (!UtilBloc.isNullOrEmpty(isChangeWorkNatureDetails) || false)
            if (!validated) {
                stopValidation = true; //flag to stop further validation
            }
        }
        this.setPropValidation(validated);
        this.setPropValue();
    }
    setPropValue = () => {
        const { generalOccupationData, isJobScopeHeavyDetails, isJobScopeHighOrLowDetails, isJobScopeChemicalDetails, isJobScopeVoltagesDetails, isJobScopeEquipmentDetails, isJobScopeVesselsDetails, isJobScopeTravelAirCraftDetails, isJobScopeEnvDetails, isAccidentDetails, isChangeWorkNatureDetails } = this.state;
        let valueobj = {
            occupation: generalOccupationData.occupation,
            isJobScopeHeavyDetails: generalOccupationData.isJobScopeNo === "Yes" ? "No" : isJobScopeHeavyDetails,
            isJobScopeHighOrLowDetails: generalOccupationData.isJobScopeNo === "Yes" ? "No" : isJobScopeHighOrLowDetails,
            isJobScopeChemicalDetails: generalOccupationData.isJobScopeNo === "Yes" ? "No" : isJobScopeChemicalDetails,
            isJobScopeEquipmentDetails: generalOccupationData.isJobScopeNo === "Yes" ? "No" : isJobScopeEquipmentDetails,
            isJobScopeVesselsDetails: generalOccupationData.isJobScopeNo === "Yes" ? "No" : isJobScopeVesselsDetails,
            isJobScopeVoltagesDetails: generalOccupationData.isJobScopeNo === "Yes" ? "No" : isJobScopeVoltagesDetails,
            isJobScopeTravelAirCraftDetails: generalOccupationData.isJobScopeNo === "Yes" ? "No" : isJobScopeTravelAirCraftDetails,
            isJobScopeEnvDetails: generalOccupationData.isJobScopeNo === "Yes" ? "No" : isJobScopeEnvDetails,
            isAccidentDetails: isAccidentDetails,
            isChangeWorkNatureDetails: isChangeWorkNatureDetails,
            isHealtAffectedByOcc: isAccidentDetails,
            workingDuration: generalOccupationData.workingDuration,
        }

        this.props.onChange(valueobj);
    }

    setPropValidation = (result) => {
        this.props.handleValidationResult(result);
    }


    async handleFormSubmit() {

    }

    showerror = (val) => {
        return val !== null && UtilBloc.isNullOrEmpty(val)
    }
    showExtraFormError = (parent, val, ind) => {
        if (parent === ind) {
            return val !== null && UtilBloc.isNullOrEmpty(val)
        }
        else
            return false
    }

    // form element start
    occupation() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.generalOccupationDetailsData.occupation}
                type={'text'}
                multiline
                showCount
                maxLength={"1000"}
                placeholder={"State all occupations if more than one..."}
                value={this.state.generalOccupationData.occupation}
                onChange={(e) => this.handleValueChange(this.getFormFields().occupation, e)}
                error={this.showerror(this.state.generalOccupationData.occupation)}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    jobScope() {
        return (
            <AppCheckboxGroup
                title={Config.proposal.formDataMapping.step1.generalOccupationDetailsData.jobScope}
                options={[
                    {
                        label: 'Lifting or moving heavey objects?', value: 'Lifting or moving heavey objects?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeHeavy,
                        checked: this.state.generalOccupationData.isJobScopeHeavy,
                        childValue: "isJobScopeHeavyDetails",
                        disabled: (this.state.generalOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="col-lg-12 col-sm-12 pl-0 pr-0">
                                <AppTextField
                                    type={'text'}
                                    multiline
                                    showCount
                                    maxLength={"1000"}
                                    placeholder={"Please specify the type of equipment..."}
                                    value={this.state.isJobScopeHeavyDetails}
                                    error={this.showExtraFormError(this.state.generalOccupationData.isJobScopeHeavy, this.state.isJobScopeHeavyDetails, "Yes")}
                                    errorMessage={this.state.errorMessage}
                                    onChange={(e) => this.handleExtraFieldFormValueChange(this.getFormFields().isJobScopeHeavyDetails, e)}
                                />
                            </div>
                    },
                    {
                        label: 'Working underground or at height', value: 'Working underground or at height',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeHighOrLow,
                        checked: this.state.generalOccupationData.isJobScopeHighOrLow,
                        childValue: "isJobScopeHighOrLowDetails",
                        disabled: (this.state.generalOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                <AppTextField
                                    type={'text'}
                                    multiline
                                    showCount
                                    maxLength={"1000"}
                                    error={this.showExtraFormError(this.state.generalOccupationData.isJobScopeHighOrLow, this.state.isJobScopeHighOrLowDetails, "Yes")}
                                    errorMessage={this.state.errorMessage}
                                    placeholder={"Please specify the depth or height involved, and the frequency involved..."}
                                    value={this.state.isJobScopeHighOrLowDetails}
                                    onChange={(e) => this.handleExtraFieldFormValueChange(this.getFormFields().isJobScopeHighOrLowDetails, e)}
                                />
                            </div>
                    },
                    {
                        label: 'Working with chemicals or gases, radioactive substances, with or near explosives?', value: 'Working with chemicals or gases, radioactive substances, with or near explosives?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeChemical,
                        checked: this.state.generalOccupationData.isJobScopeChemical,
                        childValue: "isJobScopeChemicalDetails",
                        disabled: (this.state.generalOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please specify the type of chemical/gases/radioactive substances..."}
                                        value={this.state.isJobScopeChemicalDetails}
                                        onChange={(e) => this.handleExtraFieldFormValueChange(this.getFormFields().isJobScopeChemicalDetails, e)}
                                        error={this.showExtraFormError(this.state.generalOccupationData.isJobScopeChemical, this.state.isJobScopeChemicalDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Handling high voltages?', value: 'Handling high voltages?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeVoltages,
                        checked: this.state.generalOccupationData.isJobScopeVoltages,
                        childValue: "isJobScopeVoltagesDetails",
                        disabled: (this.state.generalOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please state details..."}
                                        value={this.state.isJobScopeVoltagesDetails}
                                        onChange={(e) => this.handleExtraFieldFormValueChange(this.getFormFields().isJobScopeVoltagesDetails, e)}
                                        error={this.showExtraFormError(this.state.generalOccupationData.isJobScopeVoltages, this.state.isJobScopeVoltagesDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Working with any type of equipment or machine (e.g. tower crane, gondola, scaffoldings, bulldozers, etc.)?', value: 'Working with any type of equipment or machine (e.g. tower crane, gondola, scaffoldings, bulldozers, etc.)?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeEquipment,
                        checked: this.state.generalOccupationData.isJobScopeEquipment,
                        childValue: "isJobScopeEquipmentDetails",
                        disabled: (this.state.generalOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please specify the type of equipment..."}
                                        value={this.state.isJobScopeEquipmentDetails}
                                        onChange={(e) => this.handleExtraFieldFormValueChange(this.getFormFields().isJobScopeEquipmentDetails, e)}
                                        error={this.showExtraFormError(this.state.generalOccupationData.isJobScopeEquipment, this.state.isJobScopeEquipmentDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Working on board the vessels?', value: 'Working on board the vessels?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeVessels,
                        checked: this.state.generalOccupationData.isJobScopeVessels,
                        childValue: "isJobScopeVesselsDetails",
                        disabled: (this.state.generalOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please state details..."}
                                        value={this.state.isJobScopeVesselsDetails}
                                        onChange={(e) => this.handleExtraFieldFormValueChange(this.getFormFields().isJobScopeVesselsDetails, e)}
                                        error={this.showExtraFormError(this.state.generalOccupationData.isJobScopeVessels, this.state.isJobScopeVesselsDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Working with regular travel in privately owned or chartered aircraft?', value: 'Working with regular travel in privately owned or chartered aircraft?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeTravelAirCraft,
                        checked: this.state.generalOccupationData.isJobScopeTravelAirCraft,
                        childValue: "isJobScopeTravelAirCraftDetails",
                        disabled: (this.state.generalOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please state the frequency of travel..."}
                                        value={this.state.isJobScopeTravelAirCraftDetails}
                                        onChange={(e) => this.handleExtraFieldFormValueChange(this.getFormFields().isJobScopeTravelAirCraftDetails, e)}
                                        error={this.showExtraFormError(this.state.generalOccupationData.isJobScopeTravelAirCraft, this.state.isJobScopeTravelAirCraftDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Working in adverse environmental conditions (e.g. dust, weather, noise, etc.)?', value: 'Working in adverse environmental conditions (e.g. dust, weather, noise, etc.)?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeEnv,
                        checked: this.state.generalOccupationData.isJobScopeEnv,
                        childValue: "isJobScopeEnvDetails",
                        disabled: (this.state.generalOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please state details..."}
                                        value={this.state.isJobScopeEnvDetails}
                                        onChange={(e) => this.handleExtraFieldFormValueChange(this.getFormFields().isJobScopeEnvDetails, e)}
                                        error={this.showExtraFormError(this.state.generalOccupationData.isJobScopeEnv, this.state.isJobScopeEnvDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Don\'t have any of these', value: 'Don\'t have any of these',
                        handleValueChange: this.handleCheckBoxValueChange,
                        childValue: "All",
                        getFormField: this.getFormFields()?.isJobScopeNo,
                        checked: this.state.generalOccupationData.isJobScopeNo,
                    },

                ]}
            />
        )
    }
    isAccident() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.generalOccupationDetailsData.isAccident}
                <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            value={this.state.generalOccupationData.isAccident}
                            handleNegativePress={() =>
                                this.setState((prevState) => ({ isAccidentDetails: null }), () => { this.handleValueChange(this.getFormFields().isAccident, 'No') })}
                            handlePositivePress={() => (this.handleValueChange(this.getFormFields().isAccident, 'Yes'))}
                        />
                    </div>
                </div>
            </div>
        )
    }
    isAccidentDetails() {
        return (
            <AppTextField
                type={'text'}
                multiline
                showCount
                maxLength={"1000"}
                placeholder={"Please provide details..."}
                value={this.state.isAccidentDetails}
                onChange={(e) => this.handleExtraFieldFormValueChange(this.getFormFields().isAccidentDetails, e)}
                error={this.showExtraFormError(this.state.generalOccupationData.isAccident, this.state.isAccidentDetails, "Yes")}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    isHealtAffectedByOcc() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.generalOccupationDetailsData.isHealtAffectedByOcc}
                <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            value={this.state.generalOccupationData.isHealtAffectedByOcc}
                            handleNegativePress={() => this.handleValueChange(this.getFormFields().isHealtAffectedByOcc, 'No')}
                            handlePositivePress={() => this.handleValueChange(this.getFormFields().isHealtAffectedByOcc, 'Yes')}
                        />
                    </div>
                </div>
            </div>
        )
    }
    workingDuration() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.oilGassTitle.workingDuration}
                type={'text'}
                placeholder={"00 years"}
                value={this.state.generalOccupationData.workingDuration}
                onChange={(e) => this.handleValueChange(this.getFormFields().workingDuration, e)}
                error={this.showerror(this.state.generalOccupationData.workingDuration)}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    isChangeWork() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.generalOccupationDetailsData.isChangeWork}
                <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            value={this.state.generalOccupationData.isChangeWork}
                            handleNegativePress={() =>
                                this.setState((prevState) => ({ isChangeWorkNatureDetails: null }), () => { this.handleValueChange(this.getFormFields().isChangeWork, 'No') })}
                            handlePositivePress={() => this.handleValueChange(this.getFormFields().isChangeWork, 'Yes')}
                        />
                    </div>
                </div>
            </div>
        )
    }
    isChangeWorkNatureDetails() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.generalOccupationDetailsData.isChangeWorkNatureDetails}
                type={'text'}
                multiline
                showCount
                maxLength={"1000"}
                placeholder={"Please provide details..."}
                value={this.state.isChangeWorkNatureDetails}
                onChange={(e) => this.handleExtraFieldFormValueChange(this.getFormFields().isChangeWorkNatureDetails, e)}
                error={this.showExtraFormError(this.state.generalOccupationData.isChangeWork, this.state.isChangeWorkNatureDetails, "Yes")}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    render() {
        return (
            <>
                <span style={{ color: 'red', fontStyle: 'italic', fontSize: '14px' }}>All fields are required</span>

                <div className="w-100 mt-4" >
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-12 col-sm-12 pr-3 pl-0 ">
                            {this.occupation()}
                        </div>
                        <div className="col-lg-12 col-sm-12 pr-3 pl-0 ">
                            {this.jobScope()}
                        </div>
                    </div>
                    <div className="mt-2">
                        {this.isAccident()}
                    </div>
                    {
                        this.state.generalOccupationData.isAccident === "Yes" &&
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-12 col-sm-12 pr-3 pl-0 ">
                                {this.isAccidentDetails()}
                            </div>
                        </div>
                    }
                    <div className="mt-2">
                        {this.isHealtAffectedByOcc()}
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.workingDuration()}
                        </div>
                        <div className="col-lg-12 col-sm-12 pr-0 pl-0 ">
                            {this.isChangeWork()}
                        </div>
                        {
                            this.state.generalOccupationData.isChangeWork === "Yes" &&
                            <div className="col-lg-12 col-sm-12 pl-0 mt-2">
                                {this.isChangeWorkNatureDetails()}
                            </div>
                        }
                    </div>

                </div >
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(GeneralOccupationQuestionnaire));
